import React from 'react';
import { useOrderNotifications } from '../../context/OrderNotificationContext';

/**
 * Hook to get order notification count for Header badge from shared context
 * This prevents duplicate API calls by using the centralized notification system
 */
export const useHeaderOrderCount = () => {
    // Always call the hook at the top level (React hooks rule)
    const {
        notificationData,
        isLoading,
        isSocketConnected,
        refreshNotificationData
    } = useOrderNotifications();
    
    return {
        orderCount: notificationData?.totalActiveOrders || 0,
        receivedCount: notificationData?.receivedCount || 0,
        isLoading: isLoading || false,
        isSocketConnected: isSocketConnected || false,
        refresh: refreshNotificationData ? () => refreshNotificationData(true) : () => {}
    };
};

/**
 * Order Badge Component for Header Navigation
 */
const HeaderOrderBadge = ({ count, className = '' }) => {
    if (!count || count === 0) return null;

    return (
        <span 
            className={`
                absolute -top-1 -right-1 
                min-w-[18px] h-[18px] 
                flex items-center justify-center 
                bg-red-500 text-white 
                text-[10px] font-bold 
                rounded-full 
                px-1
                shadow-sm
                animate-pulse
                ${className}
            `}
        >
            {count > 99 ? '99+' : count}
        </span>
    );
};

export default HeaderOrderBadge;
